import { Api, IConfig } from 'elc-service';

export interface ISignInResponse {
    token_type: string;
    access_token: string;
    expires_in: number;
    userId: string;
    userEmail: string;
    userRole: string;
    userCreationDate: string;
}

export class SignInApiSdk extends Api {
    private authApiUrl: string;

    constructor(configStore: IConfig) {
        super(configStore);
        this.authApiUrl = 'stardust-account-proxy-v0/oauth';
    }

    public get tokenUrl() {
        return `/${this.authApiUrl}/token`;
    }

    public guestTokenRequest = async (): Promise<ISignInResponse> => {
        const response = await this.httpTransport.post<ISignInResponse>({
            url: this.tokenUrl,
            body: {
                grant_type: 'client_credentials'
            }
        });

        return response.data;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public signIn = async (signInData: any): Promise<ISignInResponse> => {
        const response = await this.httpTransport.post<ISignInResponse>({
            url: this.tokenUrl,
            body: signInData
        });

        return response.data;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public signOut = async (signOutData: any) => {
        return this.httpTransport.post({
            url: `/${this.authApiUrl}/revoke`,
            body: signOutData
        });
    };
}
